import { BlackJackPool } from "../blackjack_pool";
import BlackJackUtility from "../../Utility/blackJack_utility";
import BlackJackSound from "../../blackjack_sound";
import ModelData from "../../../public/model_data";

//下注动画表现
const {ccclass, property} = cc._decorator;

interface BetData{
    type:number;
    count:number;
}

@ccclass
export class BlackJackBetMoveEffect extends cc.Component {
    //bet 池
    private pool:BlackJackPool;

    private move:number = 2.5;//偏移值

    private handleArray = [];

    @property(cc.SpriteAtlas)
    spriteAtlasChip: cc.SpriteAtlas = null

    @property(cc.Node)
    prefab:cc.Node = null;

    @property(cc.Node)
    startNode:cc.Node = null;

    @property(cc.Node)
    purposeNode:cc.Node = null;

    onLoad(){
        this.pool = new BlackJackPool(this.prefab);
        this.handleArray = [1000,500,100,10,5,1]//基础值
    }

    show(){
        this.node.active = true;
    }

    hide(){
        this.node.active = false;
        this.recycleAllBet();
    }

    //下注动画-------------------------------
    checkBet(gold:number,func?:Function){
        let betArray = this.getSortBet(gold);
        let y = 0;
        let maxCount = 0;
        let moveCount = 0;
        let tempLocaltion = this.startNode.parent.convertToWorldSpaceAR(this.startNode.position);
        let localPos = this.purposeNode.convertToNodeSpaceAR(tempLocaltion);
        this.node.stopAllActions();
        BlackJackUtility.schedule(this.node,()=>{
            BlackJackSound.playBet();
            
            let data = betArray[maxCount];
            if (maxCount == betArray.length) {
                
                this.node.stopAllActions();
                if(func)
                {
                    func()
                }
            }else{
                
                let node = this.pool.obtain();
                let showTxt=node.getChildByName("coinTxt").getComponent(cc.Label)
                showTxt.string=""
                showTxt.node.active=false;
                let name = this.getBetName(data.type);
                node.stopAllActions();
                // if (!node.getComponent(cc.Sprite).spriteFrame) {
                //     cc.log('------------>>',node.name);
                // }
                node.getComponent(cc.Sprite).spriteFrame = this.getSpriteFrameByName(name);
                node.parent = this.purposeNode;
                node.active = true;
                node.position = localPos;
                BlackJackUtility.moveToAction(node,cc.v2(0,y),0.09,()=>{
                    moveCount++;
                    if (moveCount == betArray.length) {//结束时显示
                        //回收原来的
                        
                        this.recycleAllBet();
                        this.showBet(gold);
                    }
                });
                y+=this.move;
                maxCount++;
            }
        },0.1);
    }

    //对应的边池移动到玩家
    obtainBet(target:cc.Node,endNode:cc.Node,gold:number,func?:Function){
        this.recycleAllBet();
        let sworldPos = target.parent.convertToWorldSpaceAR(target.position);
        let slocalPos = this.purposeNode.convertToNodeSpaceAR(sworldPos);
        this._showBet(gold,slocalPos);
        //归池
        let children = this.purposeNode.children.concat([]);
        let maxCount = children.length-1;
        let eworldPos = endNode.parent.convertToWorldSpaceAR(endNode.position);
        let elocalPos = this.purposeNode.convertToNodeSpaceAR(eworldPos);

        //TexasSound.playReceiveBet();
        this.node.stopAllActions();
        BlackJackUtility.schedule(this.node,()=>{
            if (maxCount == -1) {
                this.node.stopAllActions();
                if(func)
                {
                    func()
                }
            }else{
                //移动动画
                let node = children[maxCount]
                if (node) {
                    node.stopAllActions();
                    BlackJackUtility.moveToAction(node,elocalPos,0.3,()=>{
                        cc.log("yidongwan")
                        //node.active = false;
                        //this.pool.recycle(node);//回收
                    })
                }
                maxCount--;
            }
        },0.07);

    }

    //归池动画 从下注 移动到池
    guiChi(target:cc.Node,func?:Function){
        //位置转换
        let tempLocaltion = target.parent.convertToWorldSpaceAR(target.position);
        //转换成相对small节点的坐标
        let localPos = this.purposeNode.convertToNodeSpaceAR(tempLocaltion);//目标位置

        //所有的归池
        let children = this.purposeNode.children.concat([]);
        let maxCount = children.length-1;
        //从大到小排序
        this.node.stopAllActions();
        BlackJackSound.playReceiveBet();
        BlackJackUtility.schedule(this.node,()=>{
            if (maxCount == -1) {
                this.node.stopAllActions();
            }else{
                //移动动画
                let node = children[maxCount]
                if (node) {
                    node.stopAllActions();
                    BlackJackUtility.moveToAction(node,localPos,0.3,()=>{
                        node.active = false;
                        this.pool.recycle(node);//回收
                    })
                }
                maxCount--;
            }
        },0.07);
    }

    //直接回收所有下注 每轮结束时执行清理
    recycleAllBet(){
        if(this.purposeNode==null)
        {
            return;
        }
        for (let bet of this.purposeNode.children.concat([])) {
            // let showTxt=bet.getChildByName("coinTxt").getComponent(cc.Label)
            // showTxt.string=""
            bet.active = false;
            this.pool.recycle(bet);
        }
    }
    //显示所下注金额
    showBet(gold:number){
        this._showBet(gold,cc.Vec2.ZERO)
    }

    private _showBet(gold:number,v:cc.Vec2){
        this.recycleAllBet();
        let betArray = this.getSortBet(gold);
        let y = 0;
        let index=0
        let showTxt:cc.Label=null
        for (const data of betArray) {
            index++
            let node = this.pool.obtain();
            // showTxt=node.getChildByName("coinTxt").getComponent(cc.Label)
            // showTxt.string=""
            // showTxt.node.active=false;
            let name = this.getBetName(data.type);
            node.stopAllActions();
            node.getComponent(cc.Sprite).spriteFrame = this.getSpriteFrameByName(name);
            node.parent = this.purposeNode;
            node.active = true;
            node.position = cc.v2(v.x,y+v.y);
            y+=this.move;

            // if(index==betArray.length)
            // {
            //     showTxt.node.active=true;
            //     showTxt.string=gold.toString()
            // }
        }
        
    }

    private getSortBet(gold:number):BetData[]{
        let bet:Array<BetData> = [];
        this._handleBetNumb(gold,0,bet);
        bet.sort(function(a:BetData,b:BetData){
            return b.type - a.type;
        })
        let betArray = [];
        for (let bt of bet) {
            for (let i = 0; i < bt.count; i++) {
                betArray.push(bt);
            }
        }
        return betArray;
    }

    private getBetName(type:number){
        // if (ModelData.instance.tableCommonData.isMangoTable) {
        //     return 'public_bet_mb';
        // }
        switch(type){
            case 0://1000
                return 'public_bet_1000';
            case 1://500
                return 'public_bet_500';
            case 2://100
                return 'public_bet_100';
            case 3://10
                return 'public_bet_10';
            case 4://5
                return 'public_bet_5';
            case 5://1
                return 'public_bet_1';
        }
    }

    //处理金币数量
    private _handleBetNumb(max:number,ct:number,arr:Array<BetData>){
        let length = arr.length;
        let base = this.handleArray[length];
        if (base == null || base == 0 || max == 0) {//错误
            return;
        }
        let listNumb = 0;
        let cnt = 0;
        if (max >= base) {
            cnt = parseInt((max / base).toString());
            ct = ct + cnt ;
        }
        listNumb = max % base;
        if (ct > 10 || max <= 0) {
            let listCount = 10 - (ct - cnt);//可以放置剩余的数量
            arr.push({type:length,count:listCount});
            return
        }
        arr.push({type:length,count:cnt});
        this._handleBetNumb(listNumb,ct,arr);
    }

    protected getSpriteFrameByName(key: string){
        return this.spriteAtlasChip.getSpriteFrame(key)
    }

    clear(){
        this.recycleAllBet();
        this.pool.clear();
    }
}
